import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=2e84cdba&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=ts&"
export * from "./settings.vue?vue&type=script&lang=ts&"
import style0 from "./settings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./settings.vue?vue&type=style&index=1&id=2e84cdba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84cdba",
  null
  
)

export default component.exports